import { chakra } from '@chakra-ui/react';
import React from 'react';

interface Props {
  size?: number;
  className?: string;
}

const STROKE_PROPS = {
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

const PATHS = [
  'M1.996 8.5H11.496',
  'M5.996 16.5H7.996',
  'M10.496 16.5H14.496',
  'M21.996 12.03V16.11C21.996 19.62 21.106 20.5 17.556 20.5H6.436' +
    'C2.886 20.5 1.996 19.62 1.996 16.11V7.89C1.996 4.38 2.886 3.5 6.436 3.5H14.496',
  'M19.076 4.131L15.366 7.841C15.226 7.981 15.086 8.261 15.056 8.461L14.856 9.881' +
    'C14.786 10.391 15.146 10.751 15.656 10.681L17.076 10.481C17.276 10.451 17.556 10.311 17.696 10.171' +
    'L21.406 6.461C22.046 5.821 22.346 5.081 21.406 4.141C20.456 3.191 19.716 3.491 19.076 4.131Z',
  'M18.547 4.66C18.867 5.79 19.747 6.67 20.867 6.98',
];

const WalletSignIcon = ({ className, size = 16 }: Props) => (
  <chakra.svg
    className={ className }
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-3 -3 30 30"
    fill="none"
    boxSize={ `${ size }px` }
    flexShrink={ 0 }
  >
    { PATHS.map((d) => <path key={ d } d={ d } { ...STROKE_PROPS }/>) }
  </chakra.svg>
);

export default WalletSignIcon;
